export default __webpack_public_path__ + "static/media/author.9326aadd.svg";